import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";
import { frFR } from "@clerk/localizations";
import { StaySignedIn } from "@/components/auth/StaySignedIn";

const appearance = {
  theme: dark,
  captcha: { theme: "dark" },
  variables: {
    colorPrimary: "#E6A45D",
    colorPrimaryForeground: "#1D140B",
    colorBackground: "#110d09",
    colorForeground: "#F7F4EE",
    colorInput: "#15110C",
    colorInputForeground: "#F7F4EE",
    colorBorder: "#6B532F",
    fontFamily: "Montserrat, sans-serif",
    borderRadius: "14px",
  },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CFG_KEY = "etm-auth-config";

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CFG_KEY)) || null; } catch { return null; }
  });
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) {
          localStorage.setItem(CFG_KEY, JSON.stringify(cfg));
          if (cancelled) return;
          return setConfig((cur) => (cur && cur.publishable_key === cfg.publishable_key && cur.proxy_url === cfg.proxy_url ? cur : cfg));
        }
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>La connexion est momentanément indisponible. Actualisez la page.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={frFR}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      <StaySignedIn />
      {children}
    </ClerkProvider>
  );
}
